import React, { useState } from "react";
import { Typography, makeStyles, Button, TextField, Checkbox, FormControlLabel, Card, CardContent, IconButton, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemAvatar, ListItemText, Avatar, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Grid, CircularProgress, LinearProgress } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useResponsive from "../../utils/useResponsive";
import ComponentsPopover from "./ComponentsPopover";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    flex: 1,
    padding: theme.spacing(4),
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  card: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    borderRadius: "12px",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.mode === "light" ? "0 2px 10px rgba(0,0,0,0.02)" : "0 2px 10px rgba(0,0,0,0.2)",
  },
  btnMargin: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  skeletonContainer: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.06)",
    borderRadius: "8px",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      transform: "translateX(-100%)",
      backgroundImage: theme.mode === "light" 
        ? "linear-gradient(90deg, rgba(255,255,255,0) 0, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 100%)"
        : "linear-gradient(90deg, rgba(0,0,0,0) 0, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)",
      animation: "$shimmer 2s infinite ease-in-out",
    }
  },
  "@keyframes shimmer": {
    "100%": { transform: "translateX(100%)" },
  },
}));

export default function ComponentDetails({ component, onBack }) {
  const classes = useStyles();
  const isMdUp = useResponsive();
  const theme = useTheme();
  const [modalOpen, setModalOpen] = useState(false);

  if (!component) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", backgroundColor: "#f0f2f5" }}>
        <Typography variant="h6" color="textSecondary">
          Selecione uma categoria ao lado
        </Typography>
      </div>
    );
  }

  const renderContent = () => {
    switch (component.id) {
      case 1:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="h1" gutterBottom>H1 - Exemplo de Título</Typography>
              <Typography variant="h2" gutterBottom>H2 - Exemplo de Título</Typography>
              <Typography variant="h3" gutterBottom>H3 - Exemplo de Título</Typography>
              <Typography variant="h4" gutterBottom>H4 - Exemplo de Título</Typography>
              <Typography variant="h5" gutterBottom>H5 - Exemplo de Título</Typography>
              <Typography variant="h6" gutterBottom>H6 - Exemplo de Título</Typography>
              <Typography variant="subtitle1" gutterBottom>Subtitle 1 - Texto de subtítulo</Typography>
              <Typography variant="body1" gutterBottom>Body 1 - Texto padrão para parágrafos. Esse é um guia de estilo.</Typography>
              <Typography variant="caption" display="block" gutterBottom>Caption - Texto menor para legendas</Typography>
            </CardContent>
          </Card>
        );
      case 2:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>Botões Contidos</Typography>
              <Button variant="contained" color="primary" className={classes.btnMargin}>Primário</Button>
              <Button variant="contained" color="secondary" className={classes.btnMargin}>Secundário</Button>
              <Button variant="contained" disabled className={classes.btnMargin}>Desativado</Button>

              <Typography variant="subtitle1" gutterBottom style={{ marginTop: 20 }}>Botões Contornados (Outlined)</Typography>
              <Button variant="outlined" color="primary" className={classes.btnMargin}>Primário</Button>
              <Button variant="outlined" color="secondary" className={classes.btnMargin}>Secundário</Button>

              <Typography variant="subtitle1" gutterBottom style={{ marginTop: 20 }}>Botões de Texto</Typography>
              <Button color="primary" className={classes.btnMargin}>Primário</Button>
              <Button color="secondary" className={classes.btnMargin}>Secundário</Button>
            </CardContent>
          </Card>
        );
      case 3:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <TextField label="Input Padrão" variant="outlined" fullWidth margin="normal" />
              <TextField label="Input com Erro" variant="outlined" fullWidth margin="normal" error helperText="Mensagem de erro" />
              <TextField label="Input Desativado" variant="outlined" fullWidth margin="normal" disabled value="Valor desativado" />
              <div style={{ marginTop: 20 }}>
                <FormControlLabel control={<Checkbox color="primary" defaultChecked />} label="Checkbox Marcado" />
                <FormControlLabel control={<Checkbox color="primary" />} label="Checkbox Desmarcado" />
              </div>
            </CardContent>
          </Card>
        );
      case 4:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                Popovers Flutuantes
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Clique no botão abaixo para ver um exemplo de Popover interativo da plataforma.
              </Typography>
              <ComponentsPopover />

              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, marginTop: 40 }}>
                Modais Padrão (Ex: Criar Conexão)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Modais são usados para formulários e configurações que exigem o foco total do usuário. Modelado com base nas telas de criação do SaaS.
              </Typography>
              <Button variant="contained" color="primary" onClick={() => setModalOpen(true)}>
                Abrir Modal de Configuração
              </Button>

              {/* Exemplo de Modal (Dialog) */}
              <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Adicionar Nova Conexão</DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    Preencha os campos abaixo para registrar uma nova conexão de WhatsApp.
                  </Typography>
                  <Grid container spacing={2} style={{ marginTop: 8 }}>
                    <Grid item xs={12}>
                      <TextField label="Nome da Conexão" variant="outlined" fullWidth size="small" />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel control={<Checkbox color="primary" defaultChecked />} label="Tornar conexão padrão" />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField label="Mensagem de Saudação" variant="outlined" fullWidth multiline rows={3} size="small" />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setModalOpen(false)} color="secondary" variant="outlined">Cancelar</Button>
                  <Button onClick={() => setModalOpen(false)} color="primary" variant="contained">Salvar</Button>
                </DialogActions>
              </Dialog>
            </CardContent>
          </Card>
        );
      case 5:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
               <Typography variant="body1">Paleta de Cores Padrão</Typography>
               <div style={{ display: 'flex', gap: '16px', marginTop: '24px', flexWrap: 'wrap' }}>
                  <div style={{ width: 100, height: 100, backgroundColor: '#1976d2', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>Primary</div>
                  <div style={{ width: 100, height: 100, backgroundColor: '#dc004e', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>Secondary</div>
                  <div style={{ width: 100, height: 100, backgroundColor: '#4caf50', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>Success</div>
                  <div style={{ width: 100, height: 100, backgroundColor: '#ff9800', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>Warning</div>
                  <div style={{ width: 100, height: 100, backgroundColor: '#f44336', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>Error</div>
               </div>
            </CardContent>
          </Card>
        );
      case 6:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary }}>
                Toasts (Notificações Flutuantes)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Utilizados para feedback dinâmico de ações (ex: salvar, deletar). Modelados com cores semânticas de alta legibilidade.
              </Typography>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Success Toast */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#edf7ed' : 'rgba(76, 175, 80, 0.1)', color: theme.mode === 'light' ? '#1e4620' : '#81c784', borderLeft: '4px solid #4caf50', boxShadow: theme.mode === 'light' ? '0 4px 12px rgba(0,0,0,0.05)' : '0 4px 12px rgba(0,0,0,0.3)' }}>
                   <Typography variant="body2" style={{ fontWeight: 600 }}>Sucesso:</Typography>
                   <Typography variant="body2" style={{ marginLeft: '8px' }}>Configurações salvas com sucesso!</Typography>
                </div>

                {/* Error Toast */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#fdeded' : 'rgba(244, 67, 54, 0.1)', color: theme.mode === 'light' ? '#5f2120' : '#e57373', borderLeft: '4px solid #f44336', boxShadow: theme.mode === 'light' ? '0 4px 12px rgba(0,0,0,0.05)' : '0 4px 12px rgba(0,0,0,0.3)' }}>
                   <Typography variant="body2" style={{ fontWeight: 600 }}>Erro:</Typography>
                   <Typography variant="body2" style={{ marginLeft: '8px' }}>Falha de conexão. Tente novamente mais tarde.</Typography>
                </div>

                {/* Warning Toast */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#fff4e5' : 'rgba(255, 152, 0, 0.1)', color: theme.mode === 'light' ? '#663c00' : '#ffb74d', borderLeft: '4px solid #ff9800', boxShadow: theme.mode === 'light' ? '0 4px 12px rgba(0,0,0,0.05)' : '0 4px 12px rgba(0,0,0,0.3)' }}>
                   <Typography variant="body2" style={{ fontWeight: 600 }}>Aviso:</Typography>
                   <Typography variant="body2" style={{ marginLeft: '8px' }}>Sua assinatura irá expirar em 3 dias.</Typography>
                </div>
                
                {/* Info Toast */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#e5f6fd' : 'rgba(3, 169, 244, 0.1)', color: theme.mode === 'light' ? '#014361' : '#4fc3f7', borderLeft: '4px solid #03a9f4', boxShadow: theme.mode === 'light' ? '0 4px 12px rgba(0,0,0,0.05)' : '0 4px 12px rgba(0,0,0,0.3)' }}>
                   <Typography variant="body2" style={{ fontWeight: 600 }}>Info:</Typography>
                   <Typography variant="body2" style={{ marginLeft: '8px' }}>Nova atualização disponível no sistema.</Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      case 7:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: 16 }}>
                Tabela Padrão de Dados
              </Typography>
              <TableContainer component={Paper} elevation={0} style={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 8, marginBottom: 32 }}>
                <Table>
                  <TableHead style={{ backgroundColor: theme.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.05)' }}>
                    <TableRow>
                      <TableCell style={{ fontWeight: 600, color: theme.palette.text.secondary }}>NOME</TableCell>
                      <TableCell style={{ fontWeight: 600, color: theme.palette.text.secondary }}>E-MAIL</TableCell>
                      <TableCell style={{ fontWeight: 600, color: theme.palette.text.secondary }}>STATUS</TableCell>
                      <TableCell align="right" style={{ fontWeight: 600, color: theme.palette.text.secondary }}>AÇÃO</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow hover>
                      <TableCell>João Silva</TableCell>
                      <TableCell>joao.silva@exemplo.com</TableCell>
                      <TableCell><Chip label="Ativo" size="small" style={{ backgroundColor: theme.mode === 'light' ? '#edf7ed' : 'rgba(76, 175, 80, 0.1)', color: theme.mode === 'light' ? '#1e4620' : '#81c784', fontWeight: 600 }} /></TableCell>
                      <TableCell align="right"><Button size="small" color="primary">Editar</Button></TableCell>
                    </TableRow>
                    <TableRow hover>
                      <TableCell>Maria Souza</TableCell>
                      <TableCell>maria.souza@exemplo.com</TableCell>
                      <TableCell><Chip label="Pendente" size="small" style={{ backgroundColor: theme.mode === 'light' ? '#fff4e5' : 'rgba(255, 152, 0, 0.1)', color: theme.mode === 'light' ? '#663c00' : '#ffb74d', fontWeight: 600 }} /></TableCell>
                      <TableCell align="right"><Button size="small" color="primary">Editar</Button></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: 16 }}>
                Lista Padrão (Exibição de Contatos/Atividades)
              </Typography>
              <Paper elevation={0} style={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 8 }}>
                <List disablePadding>
                  <ListItem button divider>
                    <ListItemAvatar>
                      <Avatar style={{ backgroundColor: theme.palette.primary.main }}>JS</Avatar>
                    </ListItemAvatar>
                    <ListItemText 
                      primary={<Typography variant="subtitle2" style={{ fontWeight: 600 }}>João Silva</Typography>} 
                      secondary="Adicionado há 2 horas" 
                    />
                  </ListItem>
                  <ListItem button>
                    <ListItemAvatar>
                      <Avatar style={{ backgroundColor: theme.palette.secondary.main }}>MS</Avatar>
                    </ListItemAvatar>
                    <ListItemText 
                      primary={<Typography variant="subtitle2" style={{ fontWeight: 600 }}>Maria Souza</Typography>} 
                      secondary="Adicionado há 5 horas" 
                    />
                  </ListItem>
                </List>
              </Paper>
            </CardContent>
          </Card>
        );
      case 8:
        return (
          <Card className={classes.card} elevation={0}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: 16 }}>
                Spinners (Circular Progress)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Indicadores contínuos ideais para carregamentos curtos, ações de botões e carregamento de pequenos blocos (cards ou painéis secundários).
              </Typography>
              <div style={{ display: 'flex', gap: '32px', alignItems: 'center', marginBottom: 40, padding: '24px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)', border: `1px dashed ${theme.palette.divider}` }}>
                <CircularProgress color="primary" />
                <CircularProgress color="secondary" />
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                   <CircularProgress color="primary" size={20} />
                   <Typography variant="body2" color="textSecondary">Processando...</Typography>
                </div>
              </div>

              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: 16 }}>
                Loaders (Linear Progress)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Indicadores de progresso linear. Muito utilizados anexados ao topo de tabelas, modais ou durante o roteamento de páginas principais da plataforma.
              </Typography>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', padding: '24px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)', border: `1px dashed ${theme.palette.divider}` }}>
                <div>
                  <LinearProgress color="primary" />
                </div>
                <div>
                  <LinearProgress color="secondary" />
                </div>
              </div>

              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: 16 }}>
                Skeletons (Carregamento de Layout / GPU-Accelerated)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
                Animações criadas com pseudo-elementos e "transform" (GPU). Zero impacto na CPU, resultando em uma transição sedosa. Usados para simular a estrutura do componente antes dos dados da API chegarem.
              </Typography>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px', borderRadius: '8px', backgroundColor: theme.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)', border: `1px dashed ${theme.palette.divider}` }}>
                {/* Skeleton Simulando Perfil/Lista */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div className={classes.skeletonContainer} style={{ width: 56, height: 56, borderRadius: '50%' }}></div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                    <div className={classes.skeletonContainer} style={{ width: '40%', height: 16 }}></div>
                    <div className={classes.skeletonContainer} style={{ width: '25%', height: 12 }}></div>
                  </div>
                </div>
                {/* Skeleton Simulando Bloco de Texto/Chat */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px' }}>
                  <div className={classes.skeletonContainer} style={{ width: '100%', height: 12 }}></div>
                  <div className={classes.skeletonContainer} style={{ width: '100%', height: 12 }}></div>
                  <div className={classes.skeletonContainer} style={{ width: '80%', height: 12 }}></div>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      default:
        return null;
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {!isMdUp && (
          <IconButton onClick={onBack} style={{ marginRight: 12 }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          {component.title}
        </Typography>
      </div>
      <div className={classes.content}>
        <Typography variant="body1" color="textSecondary" style={{ marginBottom: 16 }}>
          {component.description}
        </Typography>
        {renderContent()}
      </div>
    </div>
  );
}